export default __webpack_public_path__ + "static/media/Merriweather-Black.cfe2aa38.ttf";